import { Address, EMPTY_ADDRESS } from "./address";

export interface Client {
  id?: string;
  name: string;
  phone: string;
  email: string;
  archived: boolean;
  caseIds: string[];
  kind: "lender" | "agent" | "titleAbstractor" | "surveyor" | "other";
  additionalEmails: {
    name: string;
    email: string;
    kind: "processor" | "assistant" | "other";
  }[];
}

export const EMPTY_CLIENT: Client = {
  name: "",
  phone: "",
  email: "",
  archived: false,
  caseIds: [],
  kind: "lender",
  additionalEmails: [],
};
